'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Disclosure = require('../../../components/Disclosure/Disclosure.js');
var Box = require('../../../../../../../common/components/layout/Box/Box.js');
var Typography = require('../../../../../../../common/components/Typography.js');
var SessionContext = require('../../../../../../../common/providers/SessionContext.js');
var Currency = require('../../../../../../../common/components/Currency.js');
var nthBitHeader = require('@narvar/nth-bit-header');
var ItemDisclosure_module = require('./ItemDisclosure.module.css.js');
var ProductThumbnail = require('@narvar/nth-block-product-thumbnail');
var Thumbnail = require('@narvar/nth-bit-thumbnail');
var TextLink = require('@narvar/nth-bit-text-link');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var ProductThumbnail__default = /*#__PURE__*/_interopDefaultLegacy(ProductThumbnail);
var Thumbnail__default = /*#__PURE__*/_interopDefaultLegacy(Thumbnail);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const ItemsDisclosure = _ref => {
  var _shipment$items, _shipment$items2;
  let {
    shipment
  } = _ref;
  const {
    claimsClaimDetailsShipmentsItems,
    claimsClaimDetailsShipmentsItemsHideContent,
    claimsClaimDetailsShipmentsItemsShowContent,
    claimsItemAttrLabelColor,
    claimsItemAttrLabelQuantityClaimed,
    claimsItemAttrLabelSize,
    claimsItemAttrLabelSku
  } = nthHookTranslations.useTranslations();
  const {
    localeCountry,
    localeLanguage
  } = SessionContext.useSession();
  return /*#__PURE__*/React__default["default"].createElement(Disclosure["default"], {
    id: `items-${shipment.trackingNumber ?? ''}`,
    title: mustache__default["default"].render(claimsClaimDetailsShipmentsItems ?? '', {
      itemsCount: shipment === null || shipment === void 0 ? void 0 : (_shipment$items = shipment.items) === null || _shipment$items === void 0 ? void 0 : _shipment$items.length
    }),
    hideContentText: claimsClaimDetailsShipmentsItemsHideContent ?? '',
    showContentText: claimsClaimDetailsShipmentsItemsShowContent ?? ''
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    as: "ul",
    gap: 8,
    className: ItemDisclosure_module["default"].itemsList
  }, (_shipment$items2 = shipment.items) === null || _shipment$items2 === void 0 ? void 0 : _shipment$items2.map(item => {
    var _item$photos;
    return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      as: "li",
      gap: 2,
      key: item.sku
    }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      gap: 2,
      className: ItemDisclosure_module["default"].item
    }, /*#__PURE__*/React__default["default"].createElement(ProductThumbnail__default["default"], {
      productInfo: {
        imageUrl: item.itemImage,
        name: item === null || item === void 0 ? void 0 : item.name
      },
      s: {
        margin: 0
      }
    }), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      gap: 1
    }, item.name && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, null, item.name), item.quantity && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelQuantityClaimed ?? ''}: ${item.quantity}`), item.sku && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelSku ?? ''}: ${item.sku}`), item.color && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelColor ?? ''}: ${item.color}`), item.size && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, `${claimsItemAttrLabelSize ?? ''}: ${item.size}`), item.price && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
      value: item.price,
      locale: `${localeLanguage ?? ''}_${localeCountry ?? ''}`,
      currency: 'USD'
    })))), (_item$photos = item.photos) !== null && _item$photos !== void 0 && _item$photos.length ? /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      gap: 2
    }, /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, "Claim photos (click a photo to view full size)"), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      as: "ul",
      display: "flex",
      gap: 2,
      style: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: 0,
        margin: 0
      }
    }, item.photos.map((photo, i) => photo.url && /*#__PURE__*/React__default["default"].createElement("li", {
      key: i
    }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
      target: TextLink.TextLinkTargetType.BLANK,
      href: photo.url
    }, /*#__PURE__*/React__default["default"].createElement(Thumbnail__default["default"], {
      alt: `Claim photo: ${i}`,
      src: photo.url,
      key: photo.url
    })))))) : null);
  })));
};
var ItemsDisclosure$1 = nthHookTranslations.withTranslationsProvider(ItemsDisclosure, {
  translationKeys: ['claimsClaimDetailsShipmentsItems', 'claimsClaimDetailsShipmentsItemsHideContent', 'claimsClaimDetailsShipmentsItemsShowContent', 'claimsItemAttrLabelColor', 'claimsItemAttrLabelQuantityClaimed', 'claimsItemAttrLabelSize', 'claimsItemAttrLabelSku']
});

exports["default"] = ItemsDisclosure$1;
